<button class="button-1"   (click)="debugger2()">lift</button>
<button class="button-2" (click)="debugger3()">Deposit</button> 
<lib-lynx-front-swhc [slots]="slots" [zoneCoils]="zoneCoils" [zoneDies]="zoneDies" [zoneSingulars]="zoneSingulars"
 [getCoilStock] ="getCoilStock" [environment]="environmentSend" [cranes]="getCranes" [liftws]="liftwsSub" [depositws]="depositwsSub" (debuggerPositionLift)="debugger($event)"  (debuggerPositionDeposit)="debugger($event)"
*ngIf="slots && zoneCoils && zoneDies && zoneSingulars && getCoilStock">
</lib-lynx-front-swhc>

